import * as actionTypes from '../actions/actionTypes'
import {
    ON_SORT,
    ON_PAGINATE,
    ON_SEARCH
} from '../actions/appUserAction';

const initialState = {
    roles: [],
    selectedRoles: [],
    business: [],
    selectedBusiness: [],
    playerTypeList: [],
    selectedPlayerTypes: [],
    coachList: [],
    selectedCoaches: [],
    username: '',
    first_name: '',
    last_name: '',
    alias: '',
    max: 10,
    offset: 0,
    sortBy: 'asc',
    currColumn: 'first_name',
    usersList: [],
    totalCount: 0,
    pageNo: 1,
};


const setRolesAndBusiness = (state, action) => {
    return {
        ...state,
        roles: action.roles,
        business: action.business,
        selectedRoles: action.selectedRoles,
        selectedBusiness: action.selectedBusiness
    }
}

const onRoleChange = (state, action) => {
    return {
        ...state,
        selectedRoles: action.selectedRoles
    }
}

const onBussChange = (state,action) => {
    return {
        ...state,
        selectedBusiness: action.selectedBusiness
    }
}

const setPlayerTypeList = (state,action) => {    
    return {
        ...state,
        playerTypeList: action.playerTypeList
    }
}

const setUsersList = (state, action) => {
    return {
        ...state,
        usersList: action.usersList,
        totalCount: action.totalCount
    }
}

const setCoachList = (state, action) => {
    return {
        ...state,
        coachList: action.coachList
    }
}

const setUsername = (state, action) => {
    return {
        ...state,
        username: action.username
    }
}

const setFirstName = (state, action) => {
    return {
        ...state,
        first_name: action.first_name
    }
}

const setLastName = (state, action) => {
    return {
        ...state,
        last_name: action.last_name
    }
}

const setAlias = (state, action) => {
    return {
        ...state,
        alias: action.alias
    }
}

const setPlayerType = (state, action) => {
    return {
        ...state,
        player_type: action.player_type
    }
}

const setSelectedCoach = (state, action) => {
    return {
        ...state,
        selectedCoach: action.selectedCoach
    }
}

const setNewOffset = (state, action) => {
    return {
        ...state,
        offset: action.offset
    }
}

const appUserReducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.SET_ROLES_AND_BUSINESS: return setRolesAndBusiness(state, action);
        case actionTypes.ON_ROLE_CHANGE: return onRoleChange(state, action);
        case actionTypes.ON_BUSINESS_CHANGE: return onBussChange(state, action);
        case actionTypes.SET_PLAYER_TYPE_LIST: return setPlayerTypeList(state, action);
        case actionTypes.SET_USERS_LIST: return setUsersList(state, action)
        case actionTypes.SET_COACH_LIST: return setCoachList(state, action)
        case actionTypes.ON_USERNAME_CHANGE: return setUsername(state, action)
        case actionTypes.ON_FIRSTNAME_CHANGE: return setFirstName(state, action)
        case actionTypes.ON_LAST_NAME_CHANGE: return setLastName(state, action)
        case actionTypes.ON_ALIAS_CHANGE: return setAlias(state, action)
        case actionTypes.ON_PLAYER_TYPE_CHANGE: return setPlayerType(state, action)
        case actionTypes.ON_COACH_CHANGE: return setSelectedCoach(state, action)
        case actionTypes.SET_OFFSET: return setNewOffset(state, action)
        case ON_PAGINATE: return ({...state, pageNo: action.pageNo})
        case ON_SORT: return ({...state, currColumn: action.payload.column, sortBy: action.payload.type })
        case ON_SEARCH: return ({...state, ...action.payload})
        default:
            return state;
    }
};

export default appUserReducer;


/** WEBPACK FOOTER **
 ** ./src/store/reducer/appUserReducer.js
 **/